$(function () {
  // 100vh
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');

  /* top slide */
  const breakPoint = window.matchMedia('(min-width: 769px)');
  var slidesCount = $('.top_slide .swiper-slide').length;
  var top_slide = new Swiper('.top_slide .swiper-container', {
    loop: slidesCount > 1,
    speed: 600,
    watchOverflow: true,
    slidesPerView: 1,
    effect: 'fade',
    coverflowEffect: {
      rotate: 0,
      slideShadows: false
    },
    autoplay: {
      delay: 10000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination'
    },
    on: {
      init: function () {
        const self = this;
        if (breakPoint.matches) {
          const pcHideIndex = $.map($(".swiper-slide.pc_hide"), (element, i) => { return $(element).attr('data-swiper-slide-index') })
          const removeIndexes = [...new Set(pcHideIndex)]
          self.removeSlide(removeIndexes)
        }
      }
    }
  });
  var topics = new Swiper('.slide_topics .swiper-container', {
    loop: true,
    speed: 600,
    slidesPerView: 1.2,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    watchSlidesVisibility: true,
    observer: true,
    observeParents: true,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false
    },
    on: {
      beforeLoopFix: function () {
        $(".swiper-slide").removeClass("item");
      }
    },
    breakpoints: {
      767: {
        slidesPerView: 2.4,
        slidesOffsetBefore: 60,
      },
      1025: {
        slidesPerView: 3,
        slidesOffsetBefore: 0
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination'
    }
  });

  /* article slide */
  var articleCount = $('.product_article .product_slide .swiper-slide').length;
  var article_slide = new Swiper('.product_article .product_slide .swiper-container', {
    loop: articleCount > 1,
    speed: 600,
    watchOverflow: true,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  var slide_thumb = new Swiper('.product_article .product_thumbnail .swiper-container', {
    slidesPerView: 1,
    loop: articleCount > 1,
    effect: 'fade',
    speed: 600,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  if ($(".product_article .product_thumbnail").length) {
    article_slide.controller.control = slide_thumb;
    slide_thumb.controller.control = article_slide;
  }
  /* use thanks subscribe */
  /* recommend slide */
  var recommendCount = $('.cart_recommend .swiper-container >.swiper-wrapper >.swiper-slide').length;
  var margin = 0;
  if (recommendCount > 1) {
    margin = 20;
  }
  console.log('recommend count : ' + recommendCount);
  var cart_recommend = new Swiper('.cart_recommend .swiper-container', {
    loop: false,
    watchOverflow: true,
    speed: 600,
    slidesPerView: 1.2,
    spaceBetween: margin,
    slidesOffsetBefore: margin,
    slidesOffsetAfter: margin,
    slideToClickedSlide: false,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false
    },
    breakpoints: {
      520: {
        slidesPerView: 1.5,
        slidesOffsetBefore: margin,
        slidesOffsetAfter: margin
      },
      767: {
        loop: false,
        slidesPerView: 1.8,
        spaceBetween: 20,
        slidesOffsetBefore: margin,
        slidesOffsetAfter: margin
      },
      1025: {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 30,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination'
    }
  });

  /* scroll animation */
  $(window).on('load', function () {
    const fedein = document.querySelectorAll(".item");
    const observer = new IntersectionObserver(fadein);
    fedein.forEach(function (item) {
      observer.observe(item);
    });

    function fadein(entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          $(entry.target).delay(i * 100).queue(function (next) {
            $(entry.target).addClass("is-view");
            next();
          });
        }
      });
    }
  });

  /* menu */
  $(".header_menu").click(function () {
    $("#side_menu").fadeIn("slow").css({ "display": "flex" });
  });
  $("#side_menu .close_btn").click(function () {
    $("#side_menu").fadeOut("slow");
  });
  if ($("#side_menu").css("display") == "flex") {
    $("main").on('click touchend', function () {
      if (!$(event.target).closest(".header_menu").length) {
        $("#side_menu .close_btn").click();
      }
    });
  }

  /* pop magazine */
  $(".btn_magazine, .btn_more.magazine").click(function () {
    close_product_modal();
    $(".form_magazine .pop_magazine").prependTo(".modal_magazine .inner").hide().fadeIn(300, function () {
      $(".modal_magazine").addClass("open");
    });
    return false;
  });
  $(".modal_magazine .close_btn").click(function () {
    $(".modal_magazine").removeClass("open").delay(1000).queue(function (next) {
      $(".modal_magazine .pop_magazine").prependTo(".form_magazine .inner");
      next();
    });
  });

  /* reset form */
  $('a[href="#recover"]').click(function () {
    $("#recover").toggleClass("open");
    return false;
  });
  $("#recover .close_btn").click(function () {
    $("#recover").removeClass("open");
  });
  if ($("#recover .errors ul li").length) {
    var error_text = $("#recover .errors ul li").text();
    $('<div class="alert"><p>' + error_text + '</p></div>').appendTo("main");
  }
  if ($("#recover [role='status'] p").length) {
    $('<div class="alert"><p>メールを送信しました。</p></div>').appendTo("main");
  }

  /* article cart btn */
  $(window).scroll(function () {
    var footBar = 0;
    if ($(window).innerHeight() < 750) {
      footBar = 95;
    }
    if ($(".product_bar").length) {
      if ($(this).scrollTop() + $(window).innerHeight() > $(window).innerHeight() + footBar) {
        $("section.product_bar").addClass("on");
      } else {
        $("section.product_bar").removeClass("on");
      }
      if ($(".slide_topics").length && $(".slide_topics").is(":visible")) {
        if ($(this).scrollTop() + $(window).height() > $(".slide_topics").offset().top + $(".slide_topics").innerHeight()) {
          $("section.product_bar").addClass("off");
        } else {
          $("section.product_bar").removeClass("off");
        }
      }
    }
  });

  /* copy btn */
  var clipboard = new ClipboardJS(".copy");
  clipboard.on('success', (e) => {
    var title = "コピー"
    if (typeof e.trigger.dataset.clipboardTitle == 'string') {
      title = e.trigger.dataset.clipboardTitle;
    } else {
      title = e.trigger.outerText;
    }
    $('<div class="alert"><p>' + title + 'しました！</p></div>').appendTo("main");
  });

  /* magazine check */
  $("#marketing").click(function () {
    const willChangeVal =
      $("[name='customer[accepts_marketing]']").val() === "true"
        ? "false"
        : "true";
    $("[name='customer[accepts_marketing]']").val(willChangeVal);
  });

  /* lp foot btn */
  $(window).scroll(function () {
    // lp003 logic
    if ($(".top_product").length) {
      $(".top_product").each(function () {
        var top_product = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > top_product - windowHeight + windowHeight / 5) {
          $(".product_bar").removeClass("off");
        } else {
          $(".product_bar").addClass("off");
        }
      });
      if ($(window).scrollTop() + $(window).height() > $(".form_magazine").offset().top + $(".form_magazine").height()) {
        $(".product_bar").addClass("off");
      }
    }

  });
  // add gift option
  $(".box_select").on("click", function () {
    /* box option */
    /*
    $('.modal_box_content').html(''); // reset
    $(this).parent().siblings(".box_option").clone().appendTo(".modal_box .inner .modal_box_content").show();

    var option_list = new Swiper('.box_option .swiper-container', {
      loop: true,
      speed: 600,
      watchOverflow: true,
      slidesPerView: 1.3,
      spaceBetween: 20,
      observer: true,
      slideToClickedSlide: false,
      breakpoints: {
        767: {
          slidesPerView: 1.4,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 30
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 40,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 120
        }
      }
    });
    $(".modal_box").toggleClass("open");
    document.body.style.overflow = 'hidden';
    */
    close_product_modal();
    console.log('show modal box');
    show_modal_box(this);
  });
  $(document).on('click', '.with_wrapping_btn', function (e) {
    let parent_id = $(this).data("parent");
    let box_id = $(this).data("id");
    let parent_sku = $(this).data("sku");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: [{
          quantity: 1,
          id: parent_id
        }, {
          quantity: 1,
          id: box_id,
          properties: {
            '_parentSKU': parent_sku
          }
        }]
      }
    }).done(function (data) {
      window.location = "/cart";
    }).fail(function () {
      alert("在庫が足りませんでした。");
    });
  });
  $(".modal_box .close_btn").on("click", function () {
    /*
    var parent = $(this).siblings(".box_option").attr("variant-id");
    if (parent != undefined) {
      $(".modal_box").removeClass("open").delay(800).queue(function (next) {
        $(".modal_box .box_option").hide();
        $(".box_select").removeClass("on");
        next();
      });
    } else {
      $(".modal_box").removeClass("open");
      $(".box_select").removeClass("on");
    }
    document.body.style.overflow = 'visible';
    */
    close_modal_box(this);
  });
  // カートに追加のダブルクリック対応
  $(".btn_option").click(function () {
    $(this).css('pointer-events', 'none');
  })
});

function show_modal_box(ele) {

  $('.modal_box_content').html(''); // reset
  $(ele).parent().siblings(".box_option").clone().appendTo(".modal_box .inner .modal_box_content").show();
  /* box option */
  var option_list = new Swiper('.box_option .swiper-container', {
    speed: 600,
    watchOverflow: true,
    slidesPerView: 2.3,
    spaceBetween: 20,
    observer: true,
    slideToClickedSlide: false,
    breakpoints: {
      767: {
        slidesPerView: 2.5,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 120
      }
    }
  });
  $(".modal_box").addClass("open");
  document.body.style.overflow = 'hidden';
}
function close_modal_box(ele) {
  var parent = $(ele).siblings(".box_option").attr("variant-id");
  if (parent != undefined) {
    $(".modal_box").removeClass("open").delay(800).queue(function (next) {
      $(".modal_box .box_option").hide();
      $(".box_select").removeClass("on");
      $(".modal_box .back_btn").hide();
      next();
    });
  } else {
    $(".modal_box").removeClass("open");
    $(".box_select").removeClass("on");
    $(".modal_box .back_btn").hide();
  }
  document.body.style.overflow = 'visible';
}
function close_product_modal() {
  if ($('.modal_classic').hasClass('open')) {
    $(".modal_classic").removeClass("open").fadeOut();
    document.body.style.overflow = 'visible';
  }
}
